import { hot } from 'react-hot-loader/root';
import React, { Component } from 'react';
import '@styles/pages/app.scss';

import bg from '@images/bg.png';
import bg1 from '@images/bg1.png';
import footer from '@images/footer.png';
import back from '@images/back.png';
import back1 from '@images/back1.png';
import back2 from '@images/back2.png';
import back3 from '@images/back3.png';
import back4 from '@images/back4.png';
import rule1 from '@images/1.png';
import rule2 from '@images/2.png';
import rule3 from '@images/3.png';
import rule4 from '@images/4.png';
import rule11 from '@images/11.png';
import rule22 from '@images/22.png';
import rule33 from '@images/33.png';
import video1 from '@images/1video.mp4';
import video2 from '@images/2video.mp4';

// import ttt1 from '@images/tt1.png';
// import ttt2 from '@images/tt2.png';


// import Model from './hooks/Model/index.js';

import { data } from './utils/data';

import MainApply from './hooks/Apply/Mainapply';

import Page from './components/page/page2';

import { getURLParam } from './utils/index';
import ActApply from './utils/ActApplyStruct';
import ActFinalMatch from './utils/ActFinalMatchStruct';
// import { BaseFetch } from './context';

class App extends Component {
  constructor(props) {

    super(props);

    this.afterClose = this.afterClose.bind(this);
    this.beforeClose = this.beforeClose.bind(this);

    this.callWup = this.callWup.bind(this);
    this.tafFetch = this.tafFetch.bind(this);

    this.pageChange = this.pageChange.bind(this);
    this.pageChange1 = this.pageChange1.bind(this);

    this.getStageInfo = this.getStageInfo.bind(this);

    this.getTotalRank = this.getTotalRank.bind(this);

    this.indexChange = this.indexChange.bind(this);

    this.backSelect = this.backSelect.bind(this);

    this.listenVideo = this.listenVideo.bind(this);

    this.state = {
      modelInit: null,
      baseFetch: {
        tafJce: null,
        tafFetch: null,
        lPid_: null,
        lActId_: null,
      },   // taf调用接口方法
      login: false,
      toastMsg: '',
      pageChange: false,
      currentIndex: getURLParam('type') === '1' ? 1 : 4,  // tab切换
      currentDay: -1,  // 当前分区的阶段
      todayTips: '',  // 今日赛程提示
      wholeList: [],  // 总榜
      showList: [], // 展示榜单
      richWList: [],  // 神豪总榜
      richSLish: [],  // 神豪展示榜单
      ruleIndex: 1, // 规则页tab
      videoShow: 'hideVideo',
    };
  }

  // 禁止赛程切换弹窗
  timetoastShow_(msg) {
    if (!this.state.showToast) {
      this.setState({
        showToast: true,
        toastMsg: msg,
      })
      setTimeout(() => {
        this.setState({
          showToast: false,
          toastMsg: '',
        })
      }, 2500)
    }
  }

  listenVideo() {
    this.setState({
      videoShow: 'showVideo',
    })
  }

  callWup(moduleName, funcName, data, unpackFun) {

    const isProd = getURLParam('debug');
    const TestURL = 'http://testwebsocket.huya.com:8084?timestamp=';
    const ProdURL = 'https://cdnws.api.huya.com?timestamp=';
    // eslint-disable-next-line no-nested-ternary
    const URL = !isProd ? ProdURL : (true ? TestURL : ProdURL);
    // const URL = ProdURL;

    // eslint-disable-next-line no-undef
    const wup = new Taf.Wup();
    wup.setServant(moduleName);
    wup.setFunc(funcName);
    wup.writeStruct('tReq', data);
    const buffer = wup.encode().getBuffer();
    const timestamp = new Date().getTime();

    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-undef
      Taf.Util.ajax(URL + timestamp,
        buffer,
        value => {
          // eslint-disable-next-line no-undef
          const rsp = new Taf.Wup();
          rsp.decode(value);
          // eslint-disable-next-line new-cap
          const result = new unpackFun();
          rsp.readStruct('tRsp', result, unpackFun);
          resolve(result)
        },
        res => {
          reject(res);
        });
    })
  }
  tafFetch(moduleName, data, requ, resp) {
    // eslint-disable-next-line new-cap
    const req = requ === null ? null : new requ();
    Object.keys(data).forEach(key => {
      req[key] = data[key];
    })
    return this.callWup('wupui', moduleName, req, resp);
  }

  componentDidMount() {
    const that = this;

    window.TT.getUserInfo(data => {
      if (data.isLogined) {
        that.setState({
          login: true,
        })
      }
    })

    // taf链接
    this.setState({
      baseFetch: {
        tafFetch: this.tafFetch,
        tafJce: ActApply,
      },
    })

    if (getURLParam('type') === '1' && ['1', '2', '3'].indexOf(getURLParam('tab')) !== -1) {
      this.setState({
        currentIndex: Number(getURLParam('tab')),
      })
    } else if (getURLParam('type') === '2' && ['4', '5', '6'].indexOf(getURLParam('tab')) !== -1) {
      this.setState({
        currentIndex: Number(getURLParam('tab')),
      })
    }

    if (getURLParam('rank') === '1') {
      location.hash = 'mao'
    }

    if (this.state.currentIndex !== 0) {
      this.getStageInfo();
      if (getURLParam('type') === '1') {
        const val = data.xinshili.richRank;
        const list = val.vRankList.value.length > 50 ? val.vRankList.value.slice(0, 50) : val.vRankList.value;
        this.setState({
          richWList: list,
          richSLish: list.slice(0, 10 >= list.length ? list.length : 10),
        })
        return ;
      }
      if (getURLParam('type') === '2') {
        const val = data.zongjuexuan.richRank;
        const list = val.vRankList.value.length > 50 ? val.vRankList.value.slice(0, 50) : val.vRankList.value;
        this.setState({
          richWList: list,
          richSLish: list.slice(0, 10 >= list.length ? list.length : 10),
        })
        return ;
      }
      // this.tafFetch('getMasterRank', {iArea: getURLParam('type') === '2' ? 4 : 1}, ActFinalMatch.TotalRankReq, ActFinalMatch.MasterRankPanel).then(val => {
      //   console.log({lPid: 0, iArea: getURLParam('type')}, '大神榜数据', val);
      //   console.log(JSON.stringify(val));
      //   const list = val.vRankList.value.length > 50 ? val.vRankList.value.slice(0, 50) : val.vRankList.value;
      //   this.setState({
      //     richWList: list,
      //     richSLish: list.slice(0, 10 >= list.length ? list.length : 10),
      //   })
      // })
    }

    // 正式环境重写console.log方法，屏蔽所有打印
    if (getURLParam('debug') !== 'true') {
      // eslint-disable-next-line
      console.log = () => {
        return;
      };
    } else {
      const hyConsole = console.log;
      console.log = (msg, data) => {
        hyConsole(msg, data)
        // eslint-disable-next-line
        if (data != undefined) {
          hyConsole(msg, data)
        }
      }
    }

  }

  // 根据分区获取阶段数据
  getStageInfo() {
    if (this.state.currentIndex === 0) return;
    if (getURLParam('type') === '1') {
      this.getTotalRank(6);
      this.setState({
        currentDay: 6,
      })
      return;
    // }
    } else if (getURLParam('type') === '2') {
      this.getTotalRank(7);
      this.setState({
        currentDay: 7,
      })
      return;
    }
    // this.tafFetch('getStageInfo', {lPid: 0, iAreaId: this.state.currentIndex}, ActFinalMatch.StageInfoReq, ActFinalMatch.StageInfoRsp).then(val => {
    //   console.log('获取阶段参数', {lPid: 0, iAreaId: this.state.currentIndex}, val);
    //   this.getTotalRank(val.iStage);

    //   this.setState({
    //     currentDay: val.iStage,
    //   })
    // })
  }

  // 获取总榜单
  getTotalRank(stage) {
    if (stage === 0) return;
    this.setState({
      pageChange: false,
    })
    if (getURLParam('type') === '1') {
      let val;
      if (this.state.currentIndex === 1) {
        val = data.xinshili.youxi;
      }
      if (this.state.currentIndex === 2) {
        val = data.xinshili.yule;
      }
      if (this.state.currentIndex === 3) {
        val = data.xinshili.jiaoyou;
      }
      let list;
      if ((getURLParam('type') === '1' && stage >= 5) || (getURLParam('type') === '2' && stage >= 6)) {
        list = val.vRank.value.length > 50 ? val.vRank.value.slice(0, 50) : val.vRank.value;
      } else {
        list = val.vRank.value.length > 50 ? val.vRank.value.slice(0, 50) : val.vRank.value;
      }
      this.setState({
        wholeList: list,
        showList: list.slice(0, 10 >= list.length ? list.length : 10),
        todayTips: val.sStageTips,
        pageChange: true,
      })
      return;
    }
    if (getURLParam('type') === '2') {
      let val;
      if (this.state.currentIndex === 4) {
        val = data.zongjuexuan.youxi;
      }
      if (this.state.currentIndex === 5) {
        val = data.zongjuexuan.yule;
      }
      if (this.state.currentIndex === 6) {
        val = data.zongjuexuan.jiaoyou;
      }
      let list;
      if ((getURLParam('type') === '1' && stage >= 5) || (getURLParam('type') === '2' && stage >= 6)) {
        list = val.vRank.value.length > 50 ? val.vRank.value.slice(0, 50) : val.vRank.value;
      } else {
        list = val.vRank.value.length > 50 ? val.vRank.value.slice(0, 50) : val.vRank.value;
      }
      this.setState({
        wholeList: list,
        showList: list.slice(0, 10 >= list.length ? list.length : 10),
        todayTips: val.sStageTips,
        pageChange: true,
      })
      return;
    }
    // this.tafFetch('getTotalRank', {lPid: 0, iArea: this.state.currentIndex, iStage: stage}, ActFinalMatch.TotalRankReq, ActFinalMatch.TotalRankRsp).then(val => {
    //   console.log('获取总榜参数', {lPid: 0, iArea: this.state.currentIndex, iStage: stage}, val);
    //   console.log(JSON.stringify(val));
    //   let list;
    //   if ((getURLParam('type') === '1' && stage >= 5) || (getURLParam('type') === '2' && stage >= 6)) {
    //     list = val.vRank.value.length > 50 ? val.vRank.value.slice(0, 50) : val.vRank.value;
    //   } else {
    //     list = val.vRank.value.length > 50 ? val.vRank.value.slice(0, 50) : val.vRank.value;
    //   }
    //   this.setState({
    //     wholeList: list,
    //     showList: list.slice(0, 10 >= list.length ? list.length : 10),
    //     todayTips: val.sStageTips,
    //     pageChange: true,
    //   })
    // })
  }

  // tab切换
  indexChange(index) {
    if (this.state.currentIndex === index) return;
    this.setState({
      currentDay: -1,  // 当前分区的阶段
      todayTips: '',  // 今日赛程提示
      wholeList: [],  // 总榜
      showList: [], // 展示榜单
      pageChange: false,
    })
    this.setState({
      currentIndex: index,
    }, () => {
      this.getStageInfo();
    });
  }

  // 神豪榜切页
  pageChange(index) {
    this.setState(state => ({
      richSLish: state.richWList.slice((index) * 10, ((index + 1) * 10) > state.richWList.length ? state.richWList.length : (index + 1) * 10),
    }))
  }
  // 总榜切页
  pageChange1(index) {
    this.setState(state => ({
      showList: state.wholeList.slice((index) * 10, ((index + 1) * 10) > state.wholeList.length ? state.wholeList.length : (index + 1) * 10),
    }))
  }

  openModel() {
    if (!this.state.login) {
      // eslint-disable-next-line no-undef
      TT.login.login();
      return;
    }
    window.TT.getUserInfo(data => {
      this.setState(state => ({
        modelInit: MainApply,
        baseFetch: {
          ...state.baseFetch,
          lPid_: data.uid,
          lActId_: 201912,
        },
      }),
      )
    })
  }

  beforeClose(resolve) {
    this.setState({
      modelInit: null,
    })
    resolve();
  }

  afterClose() {

  }

  backSelect() {
    if (getURLParam('type') === '1') {
      if (this.state.currentIndex !== 0) {
        return back1;
      } else {
        return back2;
      }
    } else if (getURLParam('type') === '2') {
      if (this.state.currentIndex === 4 || this.state.currentIndex === 5) {
        if (this.state.currentDay >= 4) {
          return back4;
        } else {
          return back3;
        }
      } else if (this.state.currentIndex === 6) {
        return back1;
      } else if (this.state.currentIndex === 0) {
        if (this.state.ruleIndex === 1) {
          return back2;
        }
        return back;
      }
    }
  }

  render() {
    const tabValue = getURLParam('type') === '2' ? [
      {
        name: '游戏总决选',
        engN: 'GAME SELECTION',
        id: 4,
      }, {
        name: '娱乐总决选',
        engN: 'ENTERTAINMENT SELECTION',
        id: 5,
      }, {
        name: '交友总决选',
        engN: 'BEING FRIENDS',
        id: 6,
      }, {
        name: '活动规则',
        engN: 'ACTIVITY RULES',
        id: 0,
      },
    ] : [
      {
        name: '游戏新势力',
        engN: 'GAME FORCE',
        id: 1,
      }, {
        name: '娱乐新势力',
        engN: 'ENTERTAINMENT FORCE',
        id: 2,
      }, {
        name: '交友新势力',
        engN: 'FRIENDS FORCE',
        id: 3,
      }, {
        name: '活动规则',
        engN: 'ACTIVITY RULES',
        id: 0,
      },
    ];
    return (
      <div id="hy_wrap">
        <video
          className={this.state.videoShow}
          src={ getURLParam('type') === '1' ? video1 : video2}
          autoPlay={true}
          muted={true}
          loop={true}
          onCanPlayThrough={this.listenVideo}
          // controls
        >
            您的浏览器不支持 video 标签
        </video>
        <section className='headImg'>
          <img src = { getURLParam('type') === '1' ? bg : bg1 } />
        </section>
        <section className='mainContentCover'>
          <div className='mainContent'>
            {/* {
              getURLParam('type') === '1' &&
              <div className='applybtn' onClick={ () => this.openModel() }></div>
            } */}
            <div className='topTab'>
              <ul>
                {
                  tabValue.map(item => (
                    <li
                      className={item.id === this.state.currentIndex ? 'tabSelected' : ''}
                      key={item.id}
                      onClick={() => {
                        this.indexChange(item.id);
                      }}
                    >
                      <div>{item.name}</div>
                      <div>{item.engN}</div>
                    </li>
                  ))
                }
              </ul>
              {
                this.state.showToast &&
                <div className='timetoast'>{this.state.toastMsg}</div>
              }
            </div>
            {
              getURLParam('type') === '2'  && (this.state.currentIndex === 4 || this.state.currentIndex === 5) && this.state.currentDay >= 4 &&
              <div className='ifinalRank'>
                <div className='title'>
                  {(this.state.currentIndex === 1 || this.state.currentIndex === 4) ? '年度十大游戏主播' : '年度十大娱乐主播'}
                </div>
                <div className='ifianltop'>
                  {
                    this.state.wholeList.map(item => {
                      if (item.iRank < 4) {
                        return (
                          <div className = {'ifinal' + item.iRank} key = { JSON.stringify(item) }>
                            <div className='hhead'>
                              <img
                                src={item.tPresenter.sPortait.substring(0, item.tPresenter.sPortait.length - 4) + '_1.png'}
                                // src = { ttt1 }
                                alt={item.tPresenter.sNickName}
                                onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}
                                onError={event => {
                                  event.target.onerror = null;
                                  event.target.src = 'https://hd.huya.com/h5/yuxiImg/headError.png';
                                }}
                              />
                            </div>
                            <div className='hheadCover'></div>
                            <div className='nameText'> {item.tPresenter.sNickName} </div>
                          </div>
                        )
                      }
                      return '';
                    })
                  }
                </div>
                <div className='ifianlbottom'>
                  {
                    this.state.wholeList.map(item => {
                      if (item.iRank > 3 && item.iRank < 11) {
                        return (
                          <div className='ifinaln' key = { JSON.stringify(item) } >
                            <div className='hhead'>
                              <img
                                src={item.tPresenter.sPortait.substring(0, item.tPresenter.sPortait.length - 4) + '_2.png'}
                                // src = { ttt2 }
                                alt={item.tPresenter.sNickName}
                                onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}
                                onError={event => {
                                  event.target.onerror = null;
                                  event.target.src = 'https://hd.huya.com/h5/yuxiImg/headError.png';
                                }}
                              />
                            </div>
                            <div className='hheadCover'></div>
                            <div className='label'> {item.tPresenter.sNickName} </div>
                          </div>
                        )
                      }
                      return '';
                    })
                  }
                </div>
              </div>
            }
            {
              this.state.currentIndex !== 0 && this.state.todayTips !== '' &&
              <div className='timeLine'>{this.state.todayTips === '' ? '' : this.state.todayTips}</div>
            }
            {
              // 总决选，游戏、娱乐分区所有阶段展示的内容
              this.state.currentIndex !== 0 && getURLParam('type') === '2' && this.state.currentIndex !== 6 &&
              <React.Fragment>
                <ul className='items'>
                  {
                    this.state.showList.map((item, index) => (
                      <li key={JSON.stringify(item) + index} className='item'>
                        <div className={item.iRank < 4 ? 'itemRankSp' : 'itemRank'}><span>{item.iRank}</span></div>
                        <div className='itemMsg' onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}>
                          <div className='picture'>
                            <img
                              src={item.tPresenter.sPortait.substring(0, item.tPresenter.sPortait.length - 4) + '_3.png'}
                              alt={item.tPresenter.sNickName}
                              onError={event => {
                                event.target.onerror = null;
                                event.target.src = 'https://hd.huya.com/h5/yuxiImg/headError.png';
                              }}
                            />
                          </div>
                          <div className='intro'>
                            <div className='sdname'><p>{item.tPresenter.sNickName}</p>{ (() => {
                              if (item.tJump.lSid > 0) {
                                return <i></i>
                              } else {
                                return '';
                              }
                            })() }</div>
                            <span>{item.tPresenter.sBriefText}</span>
                          </div>
                        </div>
                        <div className='itemScore'>
                          <p>{item.lScore}</p>
                          <span>战力</span>
                        </div>
                      </li>
                    ))
                  }
                </ul>
                {
                  !!this.state.pageChange &&
                  <div className='page'>
                    <Page
                      pageLen={this.state.wholeList.length % 10 === 0 ? this.state.wholeList.length / 10 : Math.floor(this.state.wholeList.length / 10) + 1}
                      setPageIndex={this.pageChange1}
                    />
                  </div>
                }
              </React.Fragment>
            }
            {
              // 新势力，所有分区除决赛阶段展示的内容；总决选，交友分区除决赛展示的内容
              // eslint-disable-next-line max-len
              this.state.currentIndex !== 0 && ((getURLParam('type') === '1' && this.state.currentDay < 5) ||  (getURLParam('type') === '2' && this.state.currentIndex === 6 && this.state.currentDay < 6)) &&
              <React.Fragment>
                <div className='items-1'>
                  {
                    this.state.showList.length !== 0 &&
                    <ul className='items-title'>
                      {
                        ['排名', '主播昵称', '战力值'].map((item, index) => (
                          <li key={index}>{item}</li>
                        ))
                      }
                    </ul>
                  }
                  <ul className='items-rank'>
                    {
                      this.state.showList.map((item, index) => (
                        <li key={JSON.stringify(item) + index} className='item-sp'>
                          <div className={item.iRank < 3 ? 'items-itemRank items-itemRank' + item.iRank : 'items-itemRank items-itemRankn'}><span>{item.iRank}</span></div>
                          <div className='itemMsg'>
                            <div className='picture'>
                              <img
                                src={item.tPresenter.sLogoUrl}
                                alt={item.tPresenter.sNickName}
                                onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}
                                onError={event => {
                                  event.target.onerror = null;
                                  event.target.src = 'https://hd.huya.com/h5/yuxiImg/imgerror.png';
                                }}
                              />
                              {
                                item.tJump.lSid > 0 &&
                                <div className='items-living'></div>
                              }
                            </div>

                            <p>{item.tPresenter.sNickName}</p>
                          </div>
                          <div className='itemScore'>
                            <p>{item.lScore}</p>
                          </div>
                        </li>
                      ))
                    }
                  </ul>
                  {
                    this.state.showList.length === 0 &&
                      <h2>暂无数据</h2>
                  }
                  {
                    !!this.state.pageChange &&
                    <div className='page'>
                      <Page
                        pageLen={this.state.wholeList.length % 10 === 0 ? this.state.wholeList.length / 10 : Math.floor(this.state.wholeList.length / 10) + 1}
                        setPageIndex={this.pageChange1}
                      />
                    </div>
                  }
                </div>
              </React.Fragment>
            }
            {
              // 新势力，所有分区决赛阶段展示的内容；总决选，交友分区决赛展示的内容
              // eslint-disable-next-line max-len
              this.state.currentIndex !== 0 && ((getURLParam('type') === '1' && this.state.currentDay >= 5) || (getURLParam('type') === '2' && this.state.currentIndex === 6 && this.state.currentDay >= 6)) &&
              <React.Fragment>
                <div className='items-1'>
                  {
                    this.state.showList.length !== 0 && this.state.showList[0].iRank !== 1 &&
                    <ul className='items-title'>
                      {
                        ['排名', '主播昵称', '战力值'].map((item, index) => (
                          <li key={index}>{item}</li>
                        ))
                      }
                    </ul>
                  }
                  {
                    this.state.showList.length !== 0 && this.state.showList[0].iRank === 1 &&
                    <div className='items-1-top'>
                      {
                        this.state.showList.map((item, index) => {
                          if (item.iRank <= 3) {
                            return (
                              <div className={'number number' + (item.iRank)} key={JSON.stringify(item) + index}>
                                <div className='label'></div>
                                <img
                                  className='bighead'
                                  src={item.tPresenter.sLogoUrl}
                                  alt={item.tPresenter.sNickName}
                                  onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}
                                  onError={event => {
                                    event.target.onerror = null;
                                    event.target.src = 'https://hd.huya.com/h5/yuxiImg/imgerror.png';
                                  }}
                                />
                                <p className='items-top-name'><span>{item.tPresenter.sNickName}</span>{item.tJump.lSid > 0 && <span className='span-living'></span>}</p>
                                <p className='items-top-score'>{item.lScore}</p>
                              </div>
                            )
                          }
                          return '';
                        })
                      }
                    </div>
                  }
                  <ul className={
                    (() => {
                      if (this.state.showList.length !== 0 && this.state.showList[0].iRank === 1) {
                        return 'items-rank1';
                      } else {
                        return 'items-rank2';
                      }
                    })()
                  }>
                    {
                      this.state.showList.map((item, index) => {
                        if (item.iRank > 3) {
                          return <li key={JSON.stringify(item) + index} className='item-sp'>
                            <div className='items-itemRank items-itemRankn'><span>{item.iRank}</span></div>
                            <div className='itemMsg'>
                              <div className='picture'>
                                <img
                                  src={item.tPresenter.sLogoUrl}
                                  alt={item.tPresenter.sNickName}
                                  onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}
                                  onError={event => {
                                    event.target.onerror = null;
                                    event.target.src = 'https://hd.huya.com/h5/yuxiImg/imgerror.png';
                                  }}
                                />
                                {
                                  item.tJump.lSid > 0 &&
                                  <div className='items-living'></div>
                                }
                              </div>
                              <p>{item.tPresenter.sNickName}</p>
                            </div>
                            <div className='itemScore'>
                              <p>{item.lScore}</p>
                            </div>
                          </li>
                        }
                        return '';
                      })
                    }
                  </ul>
                  {
                    !!this.state.pageChange &&
                    <div className='page'>
                      <Page
                        pageLen={this.state.wholeList.length % 10 === 0 ? this.state.wholeList.length / 10 : Math.floor(this.state.wholeList.length / 10) + 1}
                        setPageIndex={this.pageChange1}
                      />
                    </div>
                  }
                  {
                    this.state.showList.length === 0 &&
                      <h2>暂无数据</h2>
                  }
                </div>
              </React.Fragment>
            }
            {
              this.state.currentIndex !== 0 &&
              <div className='richRank'>
                <a id='mao' href="#mao" rel="external nofollow" ></a>
                {
                  this.state.richSLish.length === 0 &&
                    <h2>暂无数据</h2>
                }
                {
                  this.state.richSLish.length !== 0 &&
                    <ul className='richTitle'>
                      <li>排名</li>
                      <li>神豪</li>
                      <li>贡献值</li>
                    </ul>
                }
                <div className='richList'>
                  {
                    this.state.richSLish.map(item => {
                      let rankClass = 'richNum';
                      // eslint-disable-next-line radix
                      switch (parseInt(item.iRank)) {
                        case 1:
                          rankClass = 'richNum richNum1';
                          break;
                        case 2:
                          rankClass = 'richNum richNum2';
                          break;
                        case 3:
                          rankClass = 'richNum richNum3';
                          break;

                      }
                      return (
                        <section key={JSON.stringify(item)}>
                          <div className={rankClass}>
                            {item.iRank}
                          </div>
                          <div className='richMsg'>
                            <img
                              className='anchorHead'
                              src={item.sLogoUrl}
                              alt={item.sNickName}
                              onClick={() => (window.open('https://m.huya.com/' + item.tJump.iRoomId, '_blank').location)}
                              onError={event => {
                                event.target.onerror = null;
                                event.target.src = 'https://hd.huya.com/h5/yuxiImg/imgerror.png';
                              }}/>
                            <p>{item.sNickName}</p>
                            {
                              item.lScore >= 10000000 &&
                            <i></i>
                            }
                          </div>
                          <div className='richScore'>
                            {item.lScore}
                          </div>
                        </section>
                      )
                    })
                  }
                </div>
                {
                  this.state.richWList.length !== 0 &&
                <div className='richPage'>
                  <Page
                    pageLen={this.state.richWList.length % 10 === 0 ? this.state.richWList.length / 10 : Math.floor(this.state.richWList.length / 10) + 1}
                    setPageIndex={this.pageChange}
                  />
                </div>
                }
              </div>
            }
            {
              this.state.currentIndex === 0 && getURLParam('type') === '1' &&
              <div className='rule'>
                <div className='rulefont'>
                  <ul className='fonttab'>
                    {
                      ['游戏/娱乐 冠军', '游戏/娱乐 亚军', '游戏/娱乐 季军', '交友冠军'].map((item, index) => (
                        <li
                          key = {item}
                          className = {this.state.ruleIndex === index + 1 ? 'selected' : 'noselected'}
                          onClick = { () => {
                            this.setState({
                              ruleIndex: index + 1,
                            })
                          } }
                        >{item}</li>
                      ))
                    }
                  </ul>
                  <div className='ruleImgtab'>
                    {
                      this.state.ruleIndex === 1 &&
                    <img src = { rule1 }/>
                    }
                    {
                      this.state.ruleIndex === 2 &&
                    <img src = { rule2 }/>
                    }
                    {
                      this.state.ruleIndex === 3 &&
                    <img src = { rule3 }/>
                    }
                    {
                      this.state.ruleIndex === 4 &&
                    <img src = { rule4 }/>
                    }
                  </div>
                </div>
                <div className='ruleback'></div>
              </div>
            }
            {
              this.state.currentIndex === 0 && getURLParam('type') === '2' &&
              <div className='rule'>
                <div className={this.state.ruleIndex === 1 ? 'rulefont2' : 'rulefont1'}>
                  <ul className='fonttab'>
                    {
                      ['十大游戏/娱乐 冠军', '十大游戏/娱乐 2-10名', '交友总决选'].map((item, index) => (
                        <li
                          key = {item}
                          className = {this.state.ruleIndex === index + 1 ? 'selected' : 'noselected'}
                          onClick = { () => {
                            this.setState({
                              ruleIndex: index + 1,
                            })
                          } }
                        >{item}</li>
                      ))
                    }
                  </ul>
                  <div className='ruleImgtab'>
                    {
                      this.state.ruleIndex === 1  &&
                      <img src = { rule11 }/>
                    }
                    {
                      this.state.ruleIndex === 2  &&
                      <img src = { rule22 }/>
                    }
                    {
                      this.state.ruleIndex === 3 &&
                      <img src = { rule33 }/>
                    }
                  </div>
                </div>
                <div className={getURLParam('type') === '1' ? 'ruleback' : 'ruleback1'}></div>
              </div>
            }
          </div>
        </section>
        <section className={ (() => {
          if (this.backSelect() === back) {
            return 'backImg';
          } else if (this.backSelect() === back1) {
            return 'backImg1';
          } else if (this.backSelect() === back3) {
            return 'backImg3';
          } else if (this.backSelect() === back4) {
            return 'backImg4';
          }

          return 'backImg2';
        })() }>
          <img
            src = { this.backSelect() }
          />
        </section>
        <section className='footImg'>
          <img src = { footer } />
        </section>
        {/* <BaseFetch.Provider
          value = {
            this.state.baseFetch
          }
        >
          <Model
            component = { this.state.modelInit }      // model渲染的组件（传null代表关闭model）
            insertDom = { 'root' }                    // model插入的位置（DOMid）
            shadow = { true }                         // 是否开启遮罩层
            beforeClose = { this.beforeClose }        // 关闭model 前 触发（务必在此回调内修改component为null且调用resolve）
            afterClose = { this.afterClose }          // 关闭model 后 触发
          />
        </BaseFetch.Provider> */}
      </div>
    );
  }
}

// 开启 webpack 的 HMR
export default hot(App);
